// extracted by mini-css-extract-plugin
export default {"loadingContainer":"LoadingPage_loadingContainer__i80P+","headerLogoContainer":"LoadingPage_headerLogoContainer__3MlSb","headerLogo":"LoadingPage_headerLogo__HeOzG"};